import { Stack, Typography, useTheme } from "@mui/material";
import { Lightbulb } from "lucide-react";
import type { FC, PropsWithChildren } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { IconBox } from "web_myplann/Shared/Components/IconBox";

const R = Resources.Finances.Recommendation;

type Props = {
	positive: boolean;
	description: string;
};

export const BalanceRecommendation: FC<PropsWithChildren<Props>> = ({
	positive,
	description,
	children,
}) => {
	const theme = useTheme();
	const { t } = useResource();

	const tint = positive ? theme.palette.green : theme.palette.red;

	return (
		<Stack
			direction="row"
			alignItems="flex-start"
			gap={theme.spacingTokens.md}
			bgcolor={theme.palette.background.paper}
			px={theme.spacingTokens.lg}
			py={theme.spacingTokens.lg}
			mt={theme.spacingTokens.sm}
		>
			<IconBox bg={tint[100]}>
				<Lightbulb size={theme.iconSize.md} color={tint[600]} />
			</IconBox>
			<Stack flex={1} minWidth={0}>
				<Typography
					variant="bodyStrong"
					component="h3"
					mb={theme.spacingTokens.xs}
				>
					{positive ? t(R.surplusTitle) : t(R.deficitTitle)}
				</Typography>
				<Typography variant="body2" lineHeight={theme.lineHeight.relaxed}>
					{description}
				</Typography>
				{children}
			</Stack>
		</Stack>
	);
};
